// 未使用
import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import type { EngagementPerformanceType } from '../../types';
import { commonBackInfo, highlight } from '../../utils';
import { getAllKeys, OptionsType } from '../../utils/customSelectUtils';
import { useSetEngagementDefaultValue } from '../../hooks/init';
import { engagementPerformancePlaceholder } from '../../constants/placeholder';
import GroupMultiSelect from '@/pages/home/components/GroupMultiSelect';
import './index.scss';
import {
  comments,
  engagements,
  likes,
  shares,
  titleMapFormat,
} from '../../constants/engagementPerformance';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { addFilterBuriedPoint } from '../../utils/point';

export default function EngagementPerformanceSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: EngagementPerformanceType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const { formatMessage } = useIntl();
  const [basicOptions, allKey]: [OptionsType, Array<string>] = useMemo(() => {
    const options = {
      engagements,
      likes,
      comments,
      shares,
    };

    return [options, getAllKeys(options)];
  }, []);

  const groupMultiSelectOptions = useMemo(() => {
    return Object.keys(basicOptions).map((key: string) => {
      const list = basicOptions?.[key] || [];
      return {
        groupKey: key,
        groupValue: formatMessage({ id: titleMapFormat[key] }),
        children: list,
      };
    });
  }, [formatMessage]);

  const [
    selectEngagementPerformance,
    setEngagementPerformance,
    isFirst,
    diffClassName,
  ] = useSetEngagementDefaultValue({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    backOriDefaultValue,
    defaultKey: ['comments', 'engagements', 'likes', 'shares'],
    options: allKey,
  });

  useEffect(() => {
    const data: { [key: string]: Array<{ [key: string]: number }> } = {
      engagements: [],
      likes: [],
      comments: [],
      shares: [],
    };
    const isAll = allKey.length === selectEngagementPerformance.length;
    if (!isAll) {
      selectEngagementPerformance.forEach((item) => {
        const [key, value] = item.split(':');
        const [start, end] = value.split('~');
        let info = {
          ['start_' + key]: Number(start),
        };
        if (end !== '') {
          info['end_' + key] = Number(end);
        }
        data[key].push(info);
      });
    }

    // 返回给后端的数据还会经过dealwithEngagementValue该方法的过滤
    onChange?.(
      'engagementPerformance',
      commonBackInfo(data, {
        [defaultKey]: isAll
          ? 'All'
          : selectEngagementPerformance.length === 0
          ? 'None'
          : selectEngagementPerformance.length,
      }),
    );
  }, [selectEngagementPerformance]);

  const buttonItemRender = (value: any) => {
    const [text, data] = value.split(':');
    return (
      <div className="dbo-select-channel-item">
        {formatMessage({ id: titleMapFormat[text] })}
        <span>:{data}</span>
      </div>
    );
  };

  return (
    <div className={`engagement-select-wrapper ${diffClassName}`}>
      <GroupMultiSelect
        selectNameText={engagementPerformancePlaceholder[lang]}
        options={groupMultiSelectOptions}
        titleLabel={engagementPerformancePlaceholder[lang]}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[
          selectEngagementPerformance,
          setEngagementPerformance,
        ]}
        showNumber={1}
        buttonItemRender={buttonItemRender}
        optionItemFormatter={highlight}
        onClose={() => {
          addFilterBuriedPoint(FilterButtonPoint.engagementPerformance);
        }}
      />
    </div>
  );
}
